export { LoggedOutHomepage as default, getStaticProps } from '@zoopla/homepage';
